module.exports = __webpack_public_path__ + "img/mechanic_2.654cc042.png";